module.exports = __webpack_public_path__ + "static/splash-logo-409d6c931e0aa82e1fef2e994ea745f3.svg";